export default __webpack_public_path__ + "static/media/game_over.706e5ac4.mp3";